import request from '@/utils/request'

// 查询流水分页
export function pageAccountBill(query) {
  return request({
    url: '/user/user-account-bill/page',
    method: 'get',
    params: query
  })
}